<template>
    <div class="page-wrapper">
        <HomeTopBar></HomeTopBar> <!-- để trực tiếp ngay đây thì thanh header mới hoạt động -->
        <div class="page-content">
            <router-view></router-view>
        </div>
        <div class="container-home-footer">
            <HomeFooter></HomeFooter>
        </div>
        <ButtonSocial></ButtonSocial>
        <ButtonToTop></ButtonToTop>
    </div>
</template>
<script>

import HomeFooter from './home-common/HomeFooter.vue';
import HomeTopBar from './home-common/HomeTopBar.vue';
import ButtonSocial from '@/components/common/ButtonSocial.vue'
import ButtonToTop from '@/components/common/ButtonToTop.vue'

export default {
    name: "HomeMain",
    components: {
        HomeFooter,
        HomeTopBar,
        ButtonToTop,
        ButtonSocial,
    },
}
</script>
<style scoped>

/* fix để cho footer luôn nằm dưới đáy, không thừa khoảng trống */
.page-wrapper {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    /* luôn chiếm toàn màn hình */
}
.page-content {
    flex: 1;
    /* đẩy footer xuống dưới */
}
.container-home-footer {
    margin-top: auto;
    /* footer luôn chạm đáy */
}
/* fix để cho footer luôn nằm dưới đáy, không thừa khoảng trống */

</style>